export default __webpack_public_path__ + "static/et-a5c8f4a8ceac83d74ae2ec965759cc3f.svg";